@if (loading) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}

<div class="viewport-wrapper">
  @if (noDataAvail) {
<span class="no-pdf-data">
    No Data Available!
  </span>
}
  @if (formNotAvail) {
<span class="no-pdf-data">
    {{ formNotAvailText }}
  </span>
}
  @if (pdfLoaded && !noDataAvail && fileContent) {
<iframe [src]="fileContent" 
    style="width: 100%;" [ngStyle]="{ 'height': divHeight }" allowfullscreen>
  </iframe>
}
</div>